import { useState } from 'react';
import { Stack, TextField } from '@mui/material';
import QuestionField from '../components/QuestionField';
import StepFooter from '../components/StepFooter';

const Step1General = ({ formData, setField, showErrors, onNext }) => {
  // Kept as typed text so commas/spaces aren't eaten mid-entry; parsed into the array.
  const [partnersText, setPartnersText] = useState(formData.partners.join(', '));
  const nameMissing = showErrors && !formData.experiment_name.trim();

  const handlePartnersChange = (text) => {
    setPartnersText(text);
    setField('partners', text.split(',').map((s) => s.trim()).filter(Boolean));
  };

  return (
    <>
      <Stack spacing={3.25}>
        <QuestionField
          label="Experiment name"
          required
          error={nameMissing ? 'Experiment name is required.' : ''}
        >
          <TextField
            hiddenLabel
            fullWidth
            size="small"
            placeholder="Short text"
            value={formData.experiment_name}
            onChange={(e) => setField('experiment_name', e.target.value)}
            error={nameMissing}
          />
        </QuestionField>

        <QuestionField
          label="Please identify any additional partner organizations participating in the experiment"
          helper="(include the primary programmatic designers and researchers; i.e., you do not need to include vendors or paid consultants who aren't actively designing the program and/or experiment). Please list all and separate with a comma."
        >
          <TextField
            hiddenLabel
            fullWidth
            size="small"
            placeholder="Comma separated"
            value={partnersText}
            onChange={(e) => handlePartnersChange(e.target.value)}
          />
        </QuestionField>
      </Stack>

      <StepFooter backDisabled onNext={onNext} />
    </>
  );
};

export default Step1General;
